<template>
  <div>
    <app-input-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import PeriodShiftInc from "../../../components/attendance/periodshiftinc/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-input-form": PeriodShiftInc,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('periodicincentivesetup.newperiodicattendanceincentivesetup'),
      pageTitleValue: "",
      formData: {
        payitemid: null,
        payitemcode: null,
        startdate: null,
        enddate: null,
        minattpercent: null,
        nolateness: false,
        noearlyleaving: false,
        noleaverecord: false,
        periodicdetail: [],
        stamp: 0,
        userid: this.$store.getters.userId,
      },

      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      if (this.formData.nolateness == false || this.formData.nolateness == null) {
        this.formData.nolateness = 0;
      } else {
        this.formData.nolateness = 1;
      }

       if (this.formData.noearlyleaving == false || this.formData.noearlyleaving == null) {
        this.formData.noearlyleaving = 0;
      } else {
        this.formData.noearlyleaving = 1;
      }

       if (this.formData.noleaverecord == false || this.formData.noleaverecord == null) {
        this.formData.noleaverecord = 0;
      } else {
        this.formData.noleaverecord = 1;
      }

      this.$store.dispatch('post', {url: "/periodshiftinc/create", payload: vm.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "periodshiftinclist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "periodshiftinclist" });
    },
  },
};
</script>